import { render } from "./list_card.vue?vue&type=template&id=31f4d597"
import script from "./list_card.js?vue&type=script&lang=js"
export * from "./list_card.js?vue&type=script&lang=js"

import "./list_card.vue?vue&type=style&index=0&id=31f4d597&lang=scss"

import exportComponent from "/woodpecker/src/akkoma.dev/AkkomaGang/akkoma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__